import { QuotationTaxEntity } from '../entities/quotation-tax.entity';
import { QuotationTaxModel } from '../../../../domain/models/comercial/quotation-tax.model';
export function mapQuotationTax(entity: QuotationTaxEntity): QuotationTaxModel {
  return { idImpuestoTarifa: entity.idImpuestoTarifa, idImpuesto: entity.idImpuesto,
    codigo: entity.codigo, nombre: entity.nombre, activo: entity.activo, porcentaje: entity.porcentaje,
    base: entity.base, valor: entity.valor };
}
